/* esm.sh - @floating-ui/utils@0.2.11/dom */
export * from "/*@floating-ui/utils@0.2.11/esnext/dom.mjs";
